import React, { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { authFetch } from "./utils/authFetch";

export default function Home() {
  const { user, isAuthed } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isAuthed) {
      authFetch("dashboard/stats")
        .then((data) => setStats(data))
        .catch((err) => setError(String(err)))
        .finally(() => setLoading(false));
    }
  }, [isAuthed]);

  if (!isAuthed) return <Navigate to="/login" replace />;

  return (
    <div className="p-4">
      <h3 className="mb-4 text-primary">Panou de Control</h3>
      <p className="mb-4 text-muted">Bine ai venit în sistem, {user?.user_name}!</p>
      {(user?.is_superuser || user?.perms?.includes('SETARI_WRITE')) && <Alert variant="info">
        <strong>Pregătirea firmei</strong> — verifică datele firmei, conturile și soldurile inițiale, pas cu pas.
        <Link className="btn btn-sm btn-primary ms-3" to="/configurare-ghidata">Deschide ghidul</Link>
      </Alert>}
      
      {loading ? (
        <Spinner animation="border" />
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <Row>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-primary border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Vânzări Luna Curentă</div>
                <h4 className="mb-0 text-primary">{Number(stats?.sales_month || 0).toLocaleString("ro-RO", { style: "currency", currency: "RON" })}</h4>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-danger border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Clienți Neîncasați</div>
                <h4 className="mb-0 text-danger">{Number(stats?.unpaid_sales || 0).toLocaleString("ro-RO", { style: "currency", currency: "RON" })}</h4>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-info border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Sold Casă (5311)</div>
                <h4 className="mb-0 text-info">{Number(stats?.sold_casa || 0).toLocaleString("ro-RO", { style: "currency", currency: "RON" })}</h4>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-info border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Sold Bancă (5121)</div>
                <h4 className="mb-0 text-info">{Number(stats?.sold_banca || 0).toLocaleString("ro-RO", { style: "currency", currency: "RON" })}</h4>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-warning border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Valoare Totală Stoc</div>
                <h4 className="mb-0 text-warning">{Number(stats?.total_stoc || 0).toLocaleString("ro-RO", { style: "currency", currency: "RON" })}</h4>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm border-0 border-start border-success border-4 h-100">
              <Card.Body>
                <div className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: "0.8rem" }}>Acțiuni Rapide</div>
                <div className="d-flex flex-wrap gap-2 mt-2">
                  <a href="/iesire/create" className="btn btn-sm btn-outline-success">Factură Nouă</a>
                  <a href="/cash" className="btn btn-sm btn-outline-secondary">Încasare</a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}
